import { render } from "./Displays.vue?vue&type=template&id=2cc8a176"
import script from "./Displays.vue?vue&type=script&lang=js"
export * from "./Displays.vue?vue&type=script&lang=js"

import exportComponent from "/opt/gitea/webhooker/hooks/dscontrol/kraken/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__